import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const CenterBox = styled.button<{ margin: string }>`
  display: flex;
  width: 100%;
  padding: ${({ margin }) => margin};
  justify-content: center;
  background-color: white;
`
const NavigateEvent = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px 40px;
  color: #0e6dfb;
  cursor: pointer;
  border: 2px solid #0e6dfb;
  border-radius: 12px;
  font-family: Pretendard500, sans-serif;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.72px;
`
type Props = {
  margin: string
}

const NavigateEventButton = ({ margin }: Props) => {
  return (
    <CenterBox margin={margin}>
      <NavigateEvent to={'/event'}>이벤트 목록보기</NavigateEvent>
    </CenterBox>
  )
}

export default NavigateEventButton
